import { render, staticRenderFns } from "./ReportingTableClsColumn.vue?vue&type=template&id=d2a7c9fc&"
import script from "./ReportingTableClsColumn.vue?vue&type=script&lang=js&"
export * from "./ReportingTableClsColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports